export const version = "sha2/5.3.0";
//# sourceMappingURL=_version.js.map